import api from "./api";

export const StatusUsuarioService = {
  buscarTodosVisiveis: () => api.get(`/status-usuario`)
};
